import styled from 'styled-components';

export const StyledPopularTopicsWrapper = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing['2Xl']} ${theme.spacing['2Xl']} 0 ${theme.spacing['2Xl']}`};

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing['md']};

  h4 {
    margin: ${({ theme }) => `0 0 ${theme.spacing['md']} 0`};
    padding: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm}) {
    flex-grow: 1;
  }
`;

export const StyledTopicItem = styled.button`
  background: transparent;
  border: ${({ theme }) => `${theme.border['xs']} solid ${theme.border.weak}`};
  border-radius: ${({ theme }) => theme.borderRadius['md']};
  color: ${({ theme }) => theme.text.strong};
  padding: ${({ theme }) => theme.spacing['xl']};
  ${({ theme }) => theme.label.md}
  font-family: ${({ theme }) =>
    theme.fontFamily
      .inter}, Arial, Helvetica, sans-serif !important; // otherwise overridden by Brandon Font on deployed environments

  :disabled:hover {
    cursor: default;
  }

  text-align: start;
  :hover {
    cursor: pointer;
    border-color: transparent;
    box-shadow: ${({ theme }) => `0 0 0 ${theme.border['sm']} ${theme.border.default}`};
  }
  :last-of-type {
    margin-bottom: 0;
  }
`;
